<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="list-view-item mb-base overflow-hidden">

    <template slot="no-body">
      <div class="vx-row item-details no-gutter">
        <vs-avatar color="danger" icon-pack="feather" icon="icon-alert-triangle" size="40px" style="position: absolute; top: 5px; left: 10px;" v-if="hasStock(item)"/>

        <!-- IMG COL -->
        <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center">
          <img
            :src="getImage(item)"
            :alt="item.name"
            class="grid-view-img p-4">
        </div>

        <!-- ITEM NAME & DESC COL -->
        <div class="vx-col sm:w-1/2">
          <div class="p-4 pt-6">
            <slot name="item-meta">
              <h6 class="item-name font-semibold mb-1">{{ item.name }}</h6>
              <p class="text-sm mb-4 cursor-pointer"><span class="text-primary font-semibold">{{ item.categoryName }}</span></p>
              <p class="text-sm mb-4 cursor-pointer"><span class="text-primary">{{ item.description }}</span></p>
<!--              <p class="item-description text-sm" v-if="item.cooking_instructions != ''">{{ item.cooking_instructions }}</p>-->
            </slot>
          </div>
        </div>

        <!-- PURCHASE COL -->
        <div class="vx-col sm:w-1/4 w-full flex items-center">

          <div
            class="p-4 flex flex-col w-full border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

            <div class="my-6">
              <h5 class="text-3xl font-bold text-center">{{ currencySymbol }}{{ parseFloat(getAmount(item)).toFixed(2) }}</h5>
            </div>

            <!-- SLOT: ACTION BUTTONS -->
            <slot name="action-buttons"/>
          </div>
        </div>
      </div>
    </template>

  </vx-card>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      showAmount: false,
      currencySymbol: ''
    },
    computed: {
      isInCart() {
        return (itemId) => this.$store.getters['isInCart'](itemId)
      },
      isInWishList() {
        return (itemId) => this.$store.getters['isInWishList'](itemId)
      },
    },
    methods: {
      getImage(product) {
        var image = '';
        if (product.hasOwnProperty('smallImage')) {
          image = product.smallImage == '' ? product.image : product.smallImage;
        } else {
          if (product.hasOwnProperty('image')) {
            image = product.image;
          }
        }
        if (image == '' && !product.noImage && product.hasImage) {
          var data = {
            id: parseInt(product.id),
            userId: this.$store.state.AppActiveUser.userId,
            token: this.$store.state.AppActiveUser.token
          };
          this.$http.post(deltaPOS_config.default.apiURL + '/products/small_image', data).then(response => {
            if (response.data.success) {
              var newImage = response.data.data.smallImage == '' ? response.data.data.image : response.data.data.smallImage;
              if (newImage == '') {
                this.$store.dispatch("updateProductImage", {id: product.id, noImage: true, image: ''});
              } else {
                this.$store.dispatch("updateProductImage", {id: product.id, noImage: false, image: newImage});
                image = newImage;
              }
            }
          });
        }
        return `data:image/jpeg;base64,${image}`;
      },
      // toggleItemInWishList(item) {
      //   this.$store.dispatch('eCommerce/toggleItemInWishList', item)
      // },
      // additemInCart(item) {
      //   this.$store.dispatch('eCommerce/additemInCart', item)
      // },
      // cartButtonClicked(item) {
      //   if (this.isInCart(item.objectID)) this.$router.push('/apps/eCommerce/checkout')
      //   else this.additemInCart(item)
      // },
      getAmount(item) {
        var amount = 0;
        if (this.showAmount) {
          amount = item.amount;
        } else {
          amount = item.price;
        }
        return amount;
      },
      hasStock(item) {
        var ret = false;
        if (item.hasOwnProperty('pqn')) {
          ret = item.pqn;
        }
        return ret;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .list-view-item {
    .item-name, .item-description {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .item-name {
      -webkit-line-clamp: 2;
    }

    .item-description {
      -webkit-line-clamp: 5;
    }

    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }
</style>
